const modalMassService = {
  massServiceTipography: 'Mass service',
  autocomplete: 'Service',
  date: 'Overdue Services Dates',
  errorTitle: 'Divergent equipment types',
  error: 'All the equipment types must be the same and should have at least one mass service activated at the parameters',
  comment: '[BULK] SERVICE DONE IN BULK'
}
  
export default modalMassService;